import React from 'react';
import withPLP from '../../../organisms/products';
import Algolia, { algoliaGSSP } from '../../../organisms/algolia-plp';
import { storeWrapper } from '../../../store';

const Trend = (props) => (<Algolia {...props} />);

export const getServerSideProps = storeWrapper.getServerSideProps(async (ctx) => algoliaGSSP(ctx, 'trends'));

export default withPLP(Trend);
